import { render, staticRenderFns } from "./HirebotAiModelConfig.vue?vue&type=template&id=37172925&scoped=true&"
import script from "./HirebotAiModelConfig.vue?vue&type=script&lang=js&"
export * from "./HirebotAiModelConfig.vue?vue&type=script&lang=js&"
import style0 from "./HirebotAiModelConfig.vue?vue&type=style&index=0&id=37172925&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37172925",
  null
  
)

export default component.exports